let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5z019")).then(() => parcelRequire('7o6kj'));